


const EcrdInner = () => {
    return (
        <>

            <div className="accordion-wrap mt-5 mb-5">

                <div className="l-article l-accordion l-accordion4 p-0">
                    <div className="mez slider">
                        <h3 className="l-accordion__title">
                            <span>Selection Criteria</span>
                        </h3>
                        <div className="l-accordion__content text">
                            <p className='fs-18'>
                                Applications are reviewed by the Early Career Researcher Development Program Team (The Office of the Vice President for Research) based on:
                            </p>
                            <ul className="mb-4">
                                <li>Motivation and alignment with research goals</li>
                                <li>Dean/Executive Director endorsement</li>
                                <li>Balanced cohort representation across colleges and research institutes.</li>
 
                            </ul>

                        </div>

                        <h3 className="l-accordion__title">
                            <span>Benefits of joining the Program</span>
                        </h3>
                        <div className="l-accordion__content">
                           
                            <ul className="mb-4">
                                <li>Build foundational and advanced research skills across design, ethics, writing, communication, and leadership.</li>
                                <li>Learn from Hamad Bin Khalifa University experts and global training providers through workshops and nature masterclasses.</li>
                                <li>Benefit from structured mentors who guide personal development, project decisions, and career strategy.</li>
                                <li>Join a community of peers and strengthen connections across Hamad Bin Khalifa University colleges and research institutes.</li>
                                <li>Gain institutional visibility through certification and performance frameworks from the Office of the Vice President for Research (OVPR).</li>
                            </ul>

                        </div>

                    </div>
                </div>
            </div>


            <div className="me-md-2 mb-3 pt-4">
                <h2 className="text-hbku-primary">The Program Framework and Duration</h2>
                <p className="p-b-2"><strong>Duration:</strong> 4–6 months, combining in-person workshops, online modules, mentorship meetings, and final assignments.</p>
            </div>

            <div className="accordion-wrap  mb-0">

                <div className="l-article l-accordion l-accordion4 p-0">
                    <div className="mez slider">
                        <h3 className="l-accordion__title">
                            <span>1. Four In-Person Workshops</span>
                        </h3>
                        <div className="l-accordion__content text">
                            <p className='fs-18'>
                                Delivered by subject-matter experts, the workshops are hands-on, interactive, and aligned with nature masterclasses training. Each workshop runs for a full day.
                            </p>
                            <h4 className="mb-3">
                                <span>Workshop 1: Research Design, Ethics, and Reproducibility</span>
                            </h4>
                            <ul className="mb-4">
                                <li>Refining research questions</li>
                                <li>Methodological choices</li>
                                <li>Responsible and ethical research</li>
                                <li>Peer review, authorship, and data transparency</li>
                                <li>AI for early-stage research tasks</li>
                                <li>Hands-on evaluation of participant project designs</li>

                            </ul>

                            <h4 className="mb-3">
                                <span>Workshop 2: Scholarly Writing Pipeline, Proposal to Paper</span>
                            </h4>
                            <ul className="mb-4">
                                <li>Funding strategies</li>
                                <li>Proposal structure, aims, and impact</li>
                                <li>Budgets and feasibility</li>
                                <li>Manuscript preparation</li>
                                <li>Journal fit and responding to reviewers</li>
                                <li>AI tools for drafting and editing</li>
                                <li>Hands-on proposal and manuscript development</li>
                            </ul>

                            <h4 className="mb-3">
                                <span>Workshop 3: Communicating Research, Public, Media, and Talks</span>
                            </h4>
                            <ul className="mb-4">
                                <li>Writing for public audiences</li>
                                <li>Engagement with media and policymakers</li>
                                <li>Designing visuals and message maps</li>
                                <li>Creating impactful presentations</li>
                                <li>AI-assisted messaging</li>
                                <li>Press-style summary and talk practice</li>
                            </ul>


                            <h4 className="mb-3">
                                <span>Workshop 4: Leading Your Research and Career</span>
                            </h4>
                            <ul className="mb-4">
                                <li>Leadership styles in research settings</li>
                                <li>Team dynamics and authorship negotiations</li>
                                <li>Collaboration planning</li>
                                <li>Digital and AI tools for efficiency</li>
                                <li>Academic identity and research branding</li>
                                <li>Leadership scenario practice</li>
                            </ul>
                        </div>

                        <h3 className="l-accordion__title">
                            <span>2. Online Hamad Bin Khalifa University’s Nature Masterclasses</span>
                        </h3>
                        <div className="l-accordion__content">
                            <p className='fs-18'>Participants receive full access to Hamad Bin Khalifa University’s <a href="https://masterclasses.nature.com/?gad_source=1&gad_campaignid=21751148803&gbraid=0AAAAAqb7NhpspDcm9rjq1bRp_FU5_hPyA&gclid=CjwKCAiA7LzLBhAgEiwAjMWzCH2G6EGvQ5DaO96uX2gE2pg_GzaG8wmIPGc3RcPq8cgE-p71Y68RVxoCyaIQAvD_BwE#nmo" target="_blank" rel="noopener noreferrer">Nature Masterclasses website</a>, which provides a curated collection of online courses designed to strengthen core research skills. These modules complement the in-person workshops, enabling participants to deepen their learning through high-quality, self-paced training aligned with international research standards.</p>


                        </div>

                        <h3 className="l-accordion__title">
                            <span>3. Structured Mentorship Framework</span>
                        </h3>
                        <div className="l-accordion__content">
                            <p className='fs-18'>Participants are paired with a mentor from Hamad Bin Khalifa University who:</p>
                            <ul className="mb-4">
                                <li>Meets monthly</li>
                                <li>Sets clear developmental goals</li>
                                <li>Provides guidance, networks, and structured feedback</li>
                                <li>Reviews participant reflections and progress</li>

                            </ul>

                        </div>

                        <h3 className="l-accordion__title no-accordion">
                            <span>4. End-of-program project or progress assignment </span>
                        </h3>
                        {/* <div className="l-accordion__content">
                            <p className='fs-18'>Participants are paired with a mentor from Hamad Bin Khalifa University who:</p>
                            <ul className="mb-4">
                                <li>Leadership styles in research settings</li>
                                <li>Team dynamics and authorship negotiations</li>
                                <li>Collaboration planning</li>
                                <li>Digital and AI tools for efficiency</li>
                                <li>Academic identity and research branding</li>
                                <li>Leadership scenario practice</li>
                            </ul>

                        </div> */}

                        <h3 className="l-accordion__title">
                            <span>5. Recognition and Certification</span>
                        </h3>
                        <div className="l-accordion__content">
                            <p className='fs-18'>Participants who complete the cohort program will receive:</p>
                            <ul className="mb-4">
                                <li>Hamad Bin Khalifa University’s Early Career Researcher Development Certificate</li>
                                {/* <li>Recognition in performance evaluations</li> */}
                                <li>Visibility for future institutional opportunities</li>

                            </ul>

                        </div>

                        <div className="me-md-2 mb-3 mt-5">
                            <h2 className="text-hbku-primary p-b-2">Joining Process</h2>

                            <ol className="mb-4 ps-5">
                                {/* <li>Applicants should complete the <a href="https://www.hbku.edu.qa/sites/default/files/ecrd_form.pdf" target="_blank" rel="noopener noreferrer">Early Career Researcher Development (ECRD) Cohort Application Form</a></li> */}
                                <li>Applicants should complete the <a href="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=cqTcDnEL5kaWxwpowQ3LlpG9yq5LR6lNt0zAj9nO_aZUMlVWQ0tHMEhWQUNINEcwSEpSTVBNUVZJSC4u" target="_blank" rel="noopener noreferrer">Early Career Researcher Development (ECRD) Cohort Application Form</a></li>

                            
                                <li>The Office of Vice President for Research will review and evaluate the applications, then select participants.</li>
                                <li>Selected participants will attend an orientation session and begin engaging with workshops, mentors, and online modules.</li>
                                <li>To receive the certificate, participants must:</li>

                            </ol>
                            <ul className="mb-4 ms-5">
                                <li>Attend all workshops</li>
                                <li>Complete the required nature masterclasses modules</li>
                                <li>Submit evidence of mentorship engagement</li>
                                <li>Deliver end-of-program assignments</li>
                            </ul>

                        </div>

                        <div className="me-md-2 mb-3 mt-5">
                            <h2 className="text-hbku-primary p-b-2">Contact and ownership</h2>


                            <ul className="mb-4 ms-5">
                                <li> Office of the Vice President for Research (OVPR)</li>
                                <li>Email:<a href="mailto:ecrd@hbku.edu.qa"> ecrd@hbku.edu.qa</a></li>
                                <li>Lead: ECRD Program Team</li>

                            </ul>

                        </div>
                    </div>
                </div>
            </div>


        </>


    )
}
export default EcrdInner